import { Injectable } from '@angular/core';
import { Observable, BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PushService {
  public pushDataSource = new BehaviorSubject(null);
  public pushData = this.pushDataSource.asObservable();
}
